
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class couponItem extends Vue {
  @Prop({ default: () => {} }) data: any;
  @Prop({ default: false }) isBatch: boolean;

  handleCouponDetail() {
    this.$router.push({
      path: "/couponDetail",
      query: {
        prizeTicketId: this.data.prizeTicketId,
      },
    });
  }
}
